import { render, staticRenderFns } from "./AuthenticationFptIdSuccess.vue?vue&type=template&id=6b3154d4&"
import script from "./AuthenticationFptIdSuccess.vue?vue&type=script&lang=js&"
export * from "./AuthenticationFptIdSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports